import LogAction from "../Utilities/LogAction";

function TopMenuNavigationContact() {
    return <div className="topmenunavigation-contact">
        <h4><a onClick={() => LogAction('/topmenubar kliknij telefon')} href="tel:+48224700826">22 470 08 26</a>  Warszawa, ul. Hynka 2a</h4>
    </div>
}

export default TopMenuNavigationContact;